import './Footer.css';
import React from 'react';
import { Col, Container,  Row, Image } from 'react-bootstrap';

import { motion } from 'framer-motion';
import github from '../../Assets/git-03.svg';

import linkedin from '../../Assets/in-03.svg';
import cv from '../../Assets/c-03.svg';
import { NavLink } from 'react-router-dom';
import cvEn from '../../Assets/cv-en.pdf';
import cvEs from '../../Assets/cv-es.pdf';
import email from '../../Assets/correo-03.svg';


import { useTranslation } from 'react-i18next';


const Footer = () => {
    const emailAddress = 'caporalebelen14@gmail.com';
    
    const downloadCV = () => {
        const lang = i18n.language === 'es' ? 'es' : 'en';
        const cvFile = lang === 'es' ? cvEs : cvEn;
        const link = document.createElement('a');
        link.href = cvFile;
        link.target = '_blank';
        link.download = `cv-${lang}.pdf`;
        link.click();
      };





    const { t } = useTranslation();

    const { i18n } = useTranslation();
    
      const changeLanguage = (language) => {
        i18n.changeLanguage(language);
      };

    return (
        <Container>
            <Row className='containerBanDos' id='Contact'>
                <Row className='footerBanner'>

                    <Col xxl={6} md={12} sm={12} className='contieneFotText' >
                    
                        <p className='unoSee'>{t('If you liked what you saw...')}</p>
                        <p className='dosSee'>{t('Let´s work together')} </p>

                        

                        
                    </Col>
                    <motion.div 
                initial={{ scale: 0}} 
                transition={{ duration: 1 }}
                animate={{ scale: 1}}
                className='redesOrdenFoot'>
                    <NavLink className='redesFot' to={"https://www.linkedin.com/in/mariabelencaporale/"} target="_blanck">
                        <Image className='redF' src={linkedin} />
                    </NavLink>

                    <NavLink className='redesFot' to={"https://github.com/MariaBelenCaporale"} target="_blanck">
                        <Image className='redF' src={github} />
                    </NavLink>

                    <NavLink className='redesFot'>
                     
                        <Image className='redF' src={cv} onClick={downloadCV} />
                   
                    </NavLink>

                    
                    <a className='redesFot' href="mailto:caporalebelen14@gmail.com">
                <img className='redF mai' src={email} alt="Correo electrónico" />
                </a>
                   
                </motion.div>
                
                </Row>
            </Row>

            
        </Container>
    );
}

export default Footer;
